var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal",class:{'shown': _vm.shown}},[_c('div',{staticClass:"modal-inner"},[_c('h2',{domProps:{"textContent":_vm._s(_vm.name)}}),_vm._t("default"),_c('button',{staticClass:"close",on:{"click":function($event){return _vm.$emit('close')}}},[_c('span',{staticClass:"sr-only"},[_vm._v("Close")])])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }